<template>
  <div class="header">
    <h1 class="header__title">
      {{ $t("message.reviewBooster.reviews.title") }}
    </h1>
    <div class="header__actions">
      <ui-button
        v-if="canManageTags && isCategoriesEnabled"
        @click="tagsManagerDialogVisible = true"
        outlined
        icon="icon-tags"
        class="mr-3"
      >
        {{ $t("message.reviews.tags.manageTagsBasic") }}
      </ui-button>
      <slot />
      <ui-button
        color="primary"
        class="ml-6"
        icon="icon-filter"
        @click="toggleFilterDialog"
      >
        {{ $t("message.reviews.filter") }}
      </ui-button>
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <ui-button
            :loading="isExportLoading"
            color="primary"
            icon="icon-download"
            outlined
            class="ml-6"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t("message.common.exportToFile") }}
            <v-icon class="ml-2">mdi-chevron-down</v-icon>
          </ui-button>
        </template>
        <v-list>
          <v-list-item @click="exportReviews('csv')">
            <v-list-item-title>{{
              $t("message.common.csv")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportReviews('xlsx')">
            <v-list-item-title>{{
              $t("message.common.xlsx")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <TagsManagerDialog
      v-if="tagsManagerDialogVisible"
      :is-open="tagsManagerDialogVisible"
      :tags="tags || []"
      :is-tag-loading="!tags"
      @close="tagsManagerDialogVisible = false"
      @list-update="$emit('list-update', $event)"
    />
    <FilterDialogHoc
      v-if="isFilterDialogVisible"
      :close-function="toggleFilterDialog"
      :filters="payload"
      @apply-filters="$emit('apply-filters', $event)"
    />
    <AsyncDownloadDialog
      v-if="showAsyncDownloadDialog"
      :export-id="exportId"
      @close="showAsyncDownloadDialog = false"
    />
  </div>
</template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import reviewBoosterService from "@/services/review-booster";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

const FilterDialogHoc = async () => {
  const filterDialogHoc = await import("@/components/hoc/FilterDialogHoc").then(
    m => m.default
  );
  return filterDialogHoc(() => import("@/components/Filter/dialog"));
};
export default {
  name: "ReviewBoosterHeader",
  mixins: [permissionsInfo],
  components: {
    AsyncDownloadDialog: () => import("@/components/AsyncDownloadDialog"),
    FilterDialogHoc: () => FilterDialogHoc(),
    TagsManagerDialog: () => import("@/components/Tags/TagsManagerDialog")
  },
  props: {
    tags: {
      type: Array
    },
    payload: {
      type: Object
    }
  },
  inject: {
    isCategoriesEnabled: {
      default: false
    }
  },
  data() {
    return {
      isFilterDialogVisible: false,
      tagsManagerDialogVisible: false,
      showAsyncDownloadDialog: false,
      exportId: null,
      isExportLoading: false
    };
  },
  methods: {
    toggleFilterDialog() {
      this.isFilterDialogVisible = !this.isFilterDialogVisible;
    },
    async exportReviews(file_format = "csv") {
      try {
        this.isExportLoading = true;
        const { export_id: exportId } = await serviceHandler(
          reviewBoosterService.exportReviews(
            this.payload,
            this.payload.reviewBoosterKey,
            file_format
          )
        );
        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.RB_REVIEW_LIST_EXPORT,
          file_format
        });
        this.isExportLoading = false;
        this.exportId = exportId;
        this.showAsyncDownloadDialog = true;
      } catch (err) {
        this.isExportLoading = false;
      }
    }
  }
};
</script>
<style lang="scss">
.header {
  display: flex;
  align-items: center;
  gap: $spacing * 2;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  &__title {
    font-weight: bold;
    @include font-size(30px);
    line-height: 37px;
    flex-shrink: 0;
  }

  &__actions {
    display: flex;
    align-items: center;
  }
}
</style>
